const ids = require('./ids');

module.exports = {
	...ids,
	name: 'items'
};
